<template>
	<div style="margin: 10px;overflow: hidden">
	    <div style="float: right;">
	        <Page :total="pageTotalNum"
                  :current="pageCurrent"
                  v-if="showPager"
                  :page-size="pageSize"
                  show-elevator
                  show-sizer
                  show-total
                  @on-page-size-change="pageSizeChange"
                  @on-change="changePage">
            </Page>
	    </div>
	</div>
</template>
<script>
export default{
	props:['pageTotalNum','pageCurrent','pageSize'],
	data () {
		return {
			//用props初始化这两个变量
			pageSizeTemp:this.pageSize,
			pageCurrentTemp:this.pageCurrent
		}
	},
	computed: {
		showPager : function(){
            let totalPage=this.pageTotalNum%this.pageSize==0 ? this.pageTotalNum/this.pageSize : (Math.floor(this.pageTotalNum/this.pageSize))+1;
            console.log("totalPage:"+totalPage);
                return totalPage > 1
        },
	},
	methods : {
		//改变页码时
		changePage (page) {
			this.pageCurrentTemp=page
			//改变页码时，触发 changePage事件，并传入当前页码page
			this.$emit('changePage',page)
		},
		//改变每页显示的条数
		pageSizeChange (pageSize) {
			this.pageSizeTemp=pageSize
			//改变每页显示条数时，触发 pageSizeChange事件，并传入每页显示的条数pageSize
			this.$emit('pageSizeChange',pageSize)
		}
	}
}
</script>
